var _path, _path2, _path3, _path4, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewCaseIcon = function SvgNewCaseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 129,
    viewBox: "0 0 110 129",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.128 1H93a7 7 0 0 1 7 7v113a7 7 0 0 1-7 7H8a7 7 0 0 1-7-7V27.503a7 7 0 0 1 2.252-5.144L24.38 2.856A7 7 0 0 1 29.128 1Z",
    stroke: "#2C112D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 25H17a8 8 0 0 0 8-8V2.5",
    stroke: "#000",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C112D",
    d: "M16 41h38v2H16zM16 57h38v2H16zM16 73h47v2H16zM16 89h55v2H16zM16 105h72v2H16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M99 18h2v62h-2z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 48,
    width: 46,
    height: 2,
    rx: 1,
    fill: "#2C112D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 72,
    width: 46,
    height: 2,
    rx: 1,
    transform: "rotate(-90 86 72)",
    fill: "#2C112D"
  })));
};
export default SvgNewCaseIcon;